import { z } from 'zod';

const DISCOUNT_CODE_PATTERN = /^[A-Z0-9-]+$/i;
/**
 * Buyer-facing discount code: letters, numbers, and dashes, accepted in any
 * case and normalized to uppercase. Promotion codes and affiliate codes share
 * this alphabet because a buyer types either one into the same field.
 */
function discountCodeSchema({ min, max, minMessage, }) {
    const minBounded = z.string().min(min, minMessage);
    const bounded = max === undefined ? minBounded : minBounded.max(max);
    return bounded
        .regex(DISCOUNT_CODE_PATTERN, 'Discount code can only contain letters, numbers, and dashes')
        .transform((value) => value.toUpperCase());
}

export { discountCodeSchema };
//# sourceMappingURL=discountCode.js.map
